"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIRST_PURCHASE_AT_JEP_DISCOUNT = exports.FIRST_PURCHASE_AT_JEP_DISCOUNT_CODE = void 0;
exports.FIRST_PURCHASE_AT_JEP_DISCOUNT_CODE = 'WELCOME';
exports.FIRST_PURCHASE_AT_JEP_DISCOUNT = 0.2;
//# sourceMappingURL=consts.js.map